import { Injectable } from '@angular/core';
import { CanActivateChild } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserMunicipalitiesService } from '../services/user-municipalities.service';

@Injectable({ providedIn: 'root' })
export class MunicipalityDeactivatedGuard implements CanActivateChild {
  constructor(
    public authService: AuthService,
    private userMunicipalityService: UserMunicipalitiesService,
  ) {}

  canActivateChild() {
    if (this.authService.isSystemAdmin) {
      return true;
    }

    const selectedMunicipality = this.userMunicipalityService.currentMunicipality;

    return selectedMunicipality && selectedMunicipality.isDeactivated === false;
  }
}
